<div class="aig-client u-my-8 container u-minheight-vh-60">
  <div class="row u-justify-center">
    <div class="col-12 col-md-8">
      <div class="u-ds-grid u-gap-40">
        <!-- Title -->
        <h1 class="u-color-primary1 u-fw-400 u-h1">
          Hola, {{ usuario?.nombre }}
        </h1>
        <!-- Historial de pólizas -->
        <section>
          <div class="u-ds-grid u-gap-24">
            <!-- Póliza activa -->
            <h2 class="u-color-primary1 u-fw-400 u-h2">Historial de pólizas</h2>
            <div class="u-ds-grid u-gap-24" *ngIf="isPolicyActive; else noDataActivedPolicies">
              <h3 class="u-color-primary1 u-fw-500 u-h3">Póliza activa</h3>
              <div class="u-ds-grid u-gap-16">
                <aig-card *ngFor="let card of cardActivedPolicies.slice(0,2); let i = index" [cardData]="card" (buttonClicked)="goToPoliceDetail(activePolicies[i])" body>
                  <div class="element">
                    <p class="u-fs-18 u-fw-400">
                      Número de póliza
                    </p>
                    <div class="p-flexcs">
                      <p class="u-fs-32 u-fw-500">
                        {{ activePolicies[i]?.num_Poliza }}
                      </p>
                      <i class="icon-copy"></i>
                    </div>
                  </div>
                  <div class="element">
                    <p class="u-fs-18 u-fw-400">
                      Fecha fin de cobertura
                    </p>
                    <p class="u-fw-500 u-fs-18">
                      {{
                        activePolicies[i]?.fecha_Fin_Cobertura
                          | date : "dd-MM-yyyy" : "No disponible"
                      }}
                    </p>
                  </div>
                </aig-card>
              </div>
            </div>
            <ng-template #noDataActivedPolicies>
              <div class="u-ds-grid u-mb-5">
                <div class="p-flexcc u-mb-3">
                  <p>Actualmente no tienes ninguna póliza activa.</p>
                </div>
                <div class="p-flexcc">
                  <button class="e-btn--primary p-flexcc u-fw-600">
                    <p class="aig-header__logout">Vuelve a protegerte con el seguro MicroCyber</p>
                  </button>
                </div>
              </div>
            </ng-template>
            <!-- Otras pólizas -->
            <div class="u-ds-grid u-gap-24" *ngIf="isPolicyRest">
              <h3 class="u-color-primary1 u-fw-500 u-h3">
                Otras pólizas
              </h3>
              <div class="u-ds-grid u-gap-16">
                <aig-card *ngFor="let card of cardRestPolicies.slice(0,2); let i = index" [cardData]="card" (buttonClicked)="goToPoliceDetail(restPolicies[i])" body>
                  <div class="element">
                    <p class="u-fs-18 u-fw-400">
                      Número de póliza
                    </p>
                    <div class="p-flexcs">
                      <p class="u-fs-32 u-fw-500">
                        {{ restPolicies[i]?.num_Poliza }}
                      </p>
                      <i class="icon-copy"></i>
                    </div>
                  </div>
                  <div class="element">
                    <p class="u-fs-18 u-fw-400">
                      Fecha fin de cobertura
                    </p>
                    <p class="u-fw-500 u-fs-18">
                      {{
                        restPolicies[i]?.fecha_Fin_Cobertura
                          | date : "dd-MM-yyyy" : "No disponible"
                      }}
                    </p>
                  </div>
                </aig-card>
              </div>
              <div class="aig-client__historyBtn">
                <button class="e-btn--primary p-flexcc u-gap-8 u-fs-16 u-fw-500" (click)="goToHistoryPolicy()" >
                  <p class="aig-header__logout">Ver historial completo</p>
                </button>
              </div>
            </div>
          </div>
        </section>
        <!-- Últimos siniestros -->
        <section>
          <div class="u-ds-grid u-gap-24">
            <h2 class="u-color-primary1 u-fw-400 u-h2">Últimos siniestros</h2>
            <div class="u-ds-grid u-gap-24" *ngIf="isClaim; else noDataClaims">
              <div class="p-flexce u-gap-16">
                <button class="e-btn--secondary p-flexcc u-gap-8 u-fw-500" (click)="goToNewClaim()">
                  <p class="aig-header__logout">Nuevo siniestro</p>
                </button>
                <button class="e-btn--primary p-flexcc u-gap-8 u-fw-500" (click)="goToClaimManagement()">
                  <p class="aig-header__logout">Gestión de siniestros</p>
                </button>
              </div>
              <div class="aig-client__cardsGrid u-gap-16">
                <aig-card class="u-size-per-100" *ngFor="let card of cardClaims.slice(0,2); let i = index;" [cardData]="card" [customClass]="' grid'" (buttonClicked)="goToClaimState(claimPolicy[i])" body>
                    <div class="element">
                      <p class="u-fs-18 u-fw-400">
                        Número de póliza
                      </p>
                      <div class="p-flexcs" *ngFor="let poliza of claimPolicy[i].policy">
                        <p class="u-fs-32 u-fw-500">
                          {{ poliza.num_Poliza }}
                        </p>
                        <i class="icon-copy"></i>
                      </div>
                    </div>
                    <div class="element">
                      <p class="u-fs-18 u-fw-400">
                        Número de siniestro
                      </p>
                      <div class="p-flexcs">
                        <p class="u-fs-32 u-fw-400">
                          {{ claimPolicy[i]?.numExpediente }}
                        </p>
                        <i class="icon-copy"></i>
                      </div>
                    </div>
                </aig-card>
              </div>
            </div>
          </div>
          <ng-template #noDataClaims>
            <div *ngIf="isPolicyActive">
              <div class="p-flexce">
                <button class="e-btn--secondary p-flexcc u-gap-8 u-fw-500" (click)="goToNewClaim()">
                  <p class="aig-header__logout">Nuevo siniestro</p>
                </button>
              </div>
            </div>
            <div class="c-card">
              <div class="c-card__header p-flexcc">
                <p>No existen siniestros previos</p>
              </div>
            </div>
          </ng-template>
        </section>
        <p class="u-fs-16 u-fw-400 u-text-center">
          Recuerda que para cualquier consulta puedes escribirnos a
          <a class="u-fs-18 u-fw-400 u-color-selected1 u-cursor-pointer"
            href="mailto:backoffice.caixa@icp.es">backoffice.caixa&#64;icp.es
          </a>
        </p>
      </div>
    </div>
  </div>
</div>


@if(visibleNewClaimModal){
<aig-modal-new-claim
  (hideNewClaimModal)="CloseNewClaim()"
></aig-modal-new-claim>
}

<aig-modal-rejected
  *ngIf="rejectedClaimModalVisible"
  [existenSiniestros]="resultado?.existenSiniestros ?? null"
  (hideModal)="onCloseModalRejectedClaim()"
></aig-modal-rejected>
